<template>
  <div class="container">
    <svg
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width="256"
      height="256"
      id="avatar"
    >
      <title>Simple Avatar</title>
      <desc>CREATED BY XUAN TANG, MORE INFO AT TXSTC55.GITHUB.IO</desc>
      <rect width="36" height="36" :fill="colorPair[0]"></rect>
      <mask
        id="mask__foreground"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="100"
        height="100"
      >
        <rect
          v-if="faceStyle == 0"
          x="0"
          y="0"
          width="36"
          height="36"
          :transform="
            'translate(' +
            maskDetailRandoms[0] +
            ' ' +
            maskDetailRandoms[1] +
            ') rotate(' +
            maskDetailRandoms[2] +
            ' ' +
            maskDetailRandoms[3] +
            ' ' +
            maskDetailRandoms[4] +
            ')scale(' +
            maskDetailRandoms[5] +
            ')'
          "
          :rx="maskDetailRandoms[6]"
          fill="white"
        ></rect>
        <path
          v-if="faceStyle == 1"
          :stroke-width="6 * (maskDetailRandoms[5] * 1.5)"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke="white"
          fill="white"
          d="M 18,7.75128869404 32,32 4,32 z"
          :transform="
            'translate(' +
            maskDetailRandoms[0] +
            ' ' +
            (maskDetailRandoms[1] - 2.5) +
            ') rotate(' +
            maskDetailRandoms[7] +
            ' 18 18)'
          "
        />
      </mask>
      <mask
        id="mask__background"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="100"
        height="100"
      >
        <rect id="test" x="0" y="0" width="36" height="36" fill="white"></rect>
        <rect
          v-if="faceStyle == 0"
          x="3"
          y="3"
          width="30"
          height="30"
          :transform="
            'translate(' +
            maskDetailRandoms[0] +
            ' ' +
            maskDetailRandoms[1] +
            ') rotate(' +
            maskDetailRandoms[2] +
            ' ' +
            maskDetailRandoms[3] +
            ' ' +
            maskDetailRandoms[4] +
            ')scale(' +
            maskDetailRandoms[5] +
            ')'
          "
          :rx="maskDetailRandoms[6]"
          fill="black"
        ></rect>
        <path
          v-if="faceStyle == 1"
          :stroke-width="6 * (maskDetailRandoms[5] * 1.5)"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke="black"
          fill="black"
          d="M 18,7.75128869404 32,32 4,32 z"
          :transform="
            'translate(' +
            maskDetailRandoms[0] +
            ' ' +
            (maskDetailRandoms[1] - 2.5) +
            ') rotate(' +
            maskDetailRandoms[7] +
            ' 18 18)'
          "
        />
      </mask>
      <rect
        x="0"
        y="0"
        width="36"
        height="36"
        :fill="colorPair[1]"
        mask="url(#mask__foreground)"
      ></rect>
      <g mask="url(#mask__foreground)">
        <g
          :transform="
            'translate(' +
            faceDetailRandoms[0] +
            ' ' +
            faceDetailRandoms[1] +
            ') rotate(' +
            faceDetailRandoms[2] +
            ' ' +
            faceDetailRandoms[3] +
            ' ' +
            faceDetailRandoms[4] +
            ')'
          "
        >
          <g
            :transform="
              mouthHappy
                ? ''
                : 'rotate(180 ' +
                  (mouthStartX + mouthWidth.getSize() / 2) +
                  ' ' +
                  (mouthStyle == 0
                    ? 21 + mouthYAdjustment + (2 + mouthDetailRandoms[0] / 2)
                    : arcCenter.cy +
                      Math.max(
                        Math.abs(mouthDetailRandoms[1]),
                        Math.abs(mouthDetailRandoms[2])
                      ) /
                        5 +
                      0.5) +
                  ')'
            "
          >
            <path
              v-if="mouthStyle == 0"
              :d="
                'M' +
                mouthStartX +
                ' ' +
                (21 + mouthYAdjustment) +
                'c' +
                (2 + mouthDetailRandoms[0]) +
                ' ' +
                (mouthHeight.getSize() + mouthDetailRandoms[1]) +
                ' ' +
                (mouthWidth.getSize() - (2 + mouthDetailRandoms[2])) +
                ' ' +
                (mouthHeight.getSize() + mouthDetailRandoms[3]) +
                ' ' +
                mouthWidth.getSize() +
                ' 0'
              "
              :stroke="foregroundStroke"
              fill="none"
              stroke-linecap="round"
            ></path>
            <path
              v-if="mouthStyle == 1"
              :d="
                'M' +
                (mouthStartX + mouthDetailRandoms[0] / 2) +
                ',' +
                (21 + mouthYAdjustment / 2) +
                ' a' +
                (Math.abs(mouthDetailRandoms[1]) / 5 + 0.5) +
                ', ' +
                (Math.abs(mouthDetailRandoms[2]) / 5 + 0.5) +
                ' 0' +
                ' 0,0 ' +
                mouthWidth.getSize() +
                ', ' +
                mouthDetailRandoms[3]
              "
              :fill="foregroundStroke"
            ></path>
          </g>
          <rect
            :x="leftEyeStart"
            :y="14 + eyeYAdjustment"
            :width="eyeWidth.getSize()"
            :height="eyeHeight.getSize()"
            rx="1"
            stroke="none"
            :fill="foregroundStroke"
          ></rect>
          <rect
            :x="rightEyeStart"
            :y="14 + eyeYAdjustment"
            :width="eyeWidth.getSize()"
            :height="eyeHeight.getSize()"
            rx="1"
            stroke="none"
            :fill="foregroundStroke"
          ></rect>
        </g>
      </g>
      <g mask="url(#mask__background)">
        <g
          :transform="
            'translate(' +
            faceDetailRandoms[0] +
            ' ' +
            faceDetailRandoms[1] +
            ') rotate(' +
            faceDetailRandoms[2] +
            ' ' +
            faceDetailRandoms[3] +
            ' ' +
            faceDetailRandoms[4] +
            ')'
          "
        >
          <g
            :transform="
              mouthHappy
                ? ''
                : 'rotate(180 ' +
                  (mouthStartX + mouthWidth.getSize() / 2) +
                  ' ' +
                  (mouthStyle == 0
                    ? 21 + mouthYAdjustment + (2 + mouthDetailRandoms[0] / 2)
                    : arcCenter.cy +
                      Math.max(
                        Math.abs(mouthDetailRandoms[1]),
                        Math.abs(mouthDetailRandoms[2])
                      ) /
                        5 +
                      0.5) +
                  ')'
            "
          >
            <path
              v-if="mouthStyle == 0"
              :d="
                'M' +
                mouthStartX +
                ' ' +
                (21 + mouthYAdjustment) +
                'c' +
                (2 + mouthDetailRandoms[0]) +
                ' ' +
                (mouthHeight.getSize() + mouthDetailRandoms[1]) +
                ' ' +
                (mouthWidth.getSize() - (2 + mouthDetailRandoms[2])) +
                ' ' +
                (mouthHeight.getSize() + mouthDetailRandoms[3]) +
                ' ' +
                mouthWidth.getSize() +
                ' 0'
              "
              :stroke="backgroundStroke"
              fill="none"
              stroke-linecap="round"
            ></path>
            <path
              v-if="mouthStyle == 1"
              :d="
                'M' +
                (mouthStartX + mouthDetailRandoms[0] / 2) +
                ',' +
                (21 + mouthYAdjustment / 2) +
                ' a' +
                (Math.abs(mouthDetailRandoms[1]) / 5 + 0.5) +
                ', ' +
                (Math.abs(mouthDetailRandoms[2]) / 5 + 0.5) +
                ' 0' +
                ' 0,0 ' +
                mouthWidth.getSize() +
                ', ' +
                mouthDetailRandoms[3]
              "
              :fill="backgroundStroke"
            ></path>
          </g>
          <rect
            :x="leftEyeStart"
            :y="14 + eyeYAdjustment"
            :width="eyeWidth.getSize()"
            :height="eyeHeight.getSize()"
            rx="1"
            stroke="none"
            :fill="backgroundStroke"
          ></rect>
          <rect
            :x="rightEyeStart"
            :y="14 + eyeYAdjustment"
            :width="eyeWidth.getSize()"
            :height="eyeHeight.getSize()"
            rx="1"
            stroke="none"
            :fill="backgroundStroke"
          ></rect>
        </g>
      </g>
      <!-- <path
        stroke="black"
        :d="
          'M ' +
          top_left_translated.x +
          ', ' +
          top_left_translated.y +
          ' ' +
          top_right_translated.x +
          ', ' +
          top_right_translated.y +
          ' ' +
          bot_right_translated.x +
          ', ' +
          bot_right_translated.y +
          ' ' +
          bot_left_translated.x +
          ', ' +
          bot_left_translated.y +
          ' z'
        "
      ></path>
      <path
        stroke="black"
        :d="
          'M ' +
          p1_translated.x +
          ', ' +
          p1_translated.y +
          ' ' +
          p2_translated.x +
          ', ' +
          p2_translated.y +
          ' ' +
          p3_translated.x +
          ', ' +
          p3_translated.y +
          ' z'
        "
      ></path> -->
    </svg>
    <button @click="initializationFull">ANOTHER</button>
    <button @click="downloadSVGAsText">SVG</button>
    <button @click="downloadSVGAsPNG">PNG</button>
  </div>
  <div class="createdBy">
    CREATED BY XUAN TANG<br/> NO COMMERCIAL USE<br />CONTACT: TXSTC55@GMAIL.COM<br/>MORE AT <a href="https://txstc55.github.io" target="_blank">TXSTC55.GITHUB.IO</a>
  </div>
</template>

<script>
import sizing from "../classes/sizing.js";
import colors from "../assets/colors.json";
import colorReshading from "../classes/colorReshading.js";
import geometryChecker from "../classes/geometryChecker.js";
var reshading = new colorReshading();
var gmChecker = new geometryChecker();

export default {
  name: "AvatarGenerator",
  data() {
    return {
      svgViewBoxSize: 36,
      colorPair: ["#ffffff", "#000000"],
      foregroundStroke: "#ffffee",
      backgroundStroke: "#000011",
      inverted: false,
      eyeHeight: new sizing(2, 0.25, 1.5),
      eyeWidth: new sizing(4, 0.5, 1.5),
      distanceBetweenEyes: new sizing(7, 0.7, 2),
      mouthHeight: new sizing(3, 0.5, 1.5),
      mouthWidth: new sizing(9, 0.5, 2),
      mouthDetailRandoms: [0, 0, 0, 0],
      maskDetailRandoms: [0, 0, 0, 0, 0, 0, 0, 0],
      faceDetailRandoms: [0, 0, 0, 0, 0],
      mouthYAdjustment: 0,
      eyeYAdjustment: 0,
      mouthStyle: 0, // 0 for closed, 1 for open
      faceStyle: 0, // 0 for square, 1 for triangle
      mouthHappy: true,
      arcCenter: { cx: 0, cy: 0 },
      colorPick: 0,
    };
  },
  methods: {
    randomFloat(min, max) {
      return Math.random() * (max - min) + min;
    },
    initializeMouthDetail() {
      this.mouthDetailRandoms[0] = this.randomFloat(-2, 2); // mouth height displacement
      this.mouthDetailRandoms[2] = this.randomFloat(-2, 2); // mouth height displacement
      this.mouthDetailRandoms[1] = this.randomFloat(-1.5, 1.5); // mouth width displacement
      this.mouthDetailRandoms[3] = this.randomFloat(-1.5, 1.5); // mouth width displacement
    },
    initializeMaskDetail() {
      this.maskDetailRandoms[0] = this.randomFloat(-5, 5); // translate x
      this.maskDetailRandoms[1] = this.randomFloat(-5, 5); // translate y
      this.maskDetailRandoms[2] = this.randomFloat(-20, 20); // rotate degree
      this.maskDetailRandoms[3] = this.randomFloat(0, 36); // rotate around x
      this.maskDetailRandoms[4] = this.randomFloat(0, 36); // rotate around y
      this.maskDetailRandoms[5] = this.randomFloat(1.0, 1.2); // scale
      this.maskDetailRandoms[6] = this.randomFloat(4, 36); // radius
      this.maskDetailRandoms[7] = this.randomFloat(-30, 30); // rotate triangle
    },
    initializeFaceDetail() {
      this.faceDetailRandoms[0] = this.randomFloat(-5, 5); // translate x
      this.faceDetailRandoms[1] = this.randomFloat(-5, 5); // translate y
      this.faceDetailRandoms[2] = this.randomFloat(-10, 10); // rotate degree
      this.faceDetailRandoms[3] = this.randomFloat(18, 36); // rotate around x
      this.faceDetailRandoms[4] = this.randomFloat(18, 36); // rotate around y
    },
    initialization() {
      this.eyeHeight.randomize();
      this.eyeWidth.randomize();
      this.distanceBetweenEyes.randomize();
      this.eyeYAdjustment = this.randomFloat(
        -5,
        this.svgViewBoxSize / 2 - 14 - this.eyeHeight.getSize()
      );
      this.mouthYAdjustment = this.randomFloat(
        14 + this.eyeYAdjustment + this.eyeHeight.getSize() + 3 - 21,
        5
      );
      this.mouthHeight.randomize();
      this.mouthWidth.randomize();
      this.initializeMouthDetail();
      this.initializeMaskDetail();
      this.initializeFaceDetail();
      this.arcCenter = gmChecker.svgArcToCenterParam(
        this.mouthStartX + this.mouthDetailRandoms[0] / 2,
        21 + this.mouthYAdjustment / 2,
        Math.abs(this.mouthDetailRandoms[1]) + 0.5,
        Math.abs(this.mouthDetailRandoms[2]) / 5 + 0.0,
        0,
        0,
        0,
        this.mouthWidth.getSize(),
        this.mouthDetailRandoms[3]
      );
    },

    checkIfMostlyInside() {
      var x_min =
        Math.min(this.leftEyeStart, this.mouthStartX) +
        this.faceDetailRandoms[0];
      var y_min = 14 + this.eyeYAdjustment + this.faceDetailRandoms[1];
      var x_max =
        Math.max(
          this.rightEyeStart + this.eyeWidth.getSize(),
          this.mouthStartX + this.mouthWidth.getSize()
        ) + this.faceDetailRandoms[0];
      var y_max = 21 + this.mouthHeight.getSize() + this.faceDetailRandoms[1];
      this.top_left_translated = gmChecker.computeRotatedPoint(
        x_min,
        y_min,
        this.faceDetailRandoms[2],
        this.faceDetailRandoms[3],
        this.faceDetailRandoms[4]
      );
      this.bot_right_translated = gmChecker.computeRotatedPoint(
        x_max,
        y_max,
        this.faceDetailRandoms[2],
        this.faceDetailRandoms[3],
        this.faceDetailRandoms[4]
      );
      this.bot_left_translated = gmChecker.computeRotatedPoint(
        x_min,
        y_max,
        this.faceDetailRandoms[2],
        this.faceDetailRandoms[3],
        this.faceDetailRandoms[4]
      );
      this.top_right_translated = gmChecker.computeRotatedPoint(
        x_max,
        y_min,
        this.faceDetailRandoms[2],
        this.faceDetailRandoms[3],
        this.faceDetailRandoms[4]
      );
      if (this.faceStyle == 0) {
        x_min = 3;
        y_min = 3;
        x_max = 33;
        y_max = 33;
        var top_left_translated_mask = gmChecker.computeRotatedPoint(
          x_min,
          y_min,
          this.maskDetailRandoms[2],
          this.maskDetailRandoms[3],
          this.maskDetailRandoms[4]
        );
        var bot_right_translated_mask = gmChecker.computeRotatedPoint(
          x_max,
          y_max,
          this.maskDetailRandoms[2],
          this.maskDetailRandoms[3],
          this.maskDetailRandoms[4]
        );
        var bot_left_translated_mask = gmChecker.computeRotatedPoint(
          x_min,
          y_max,
          this.maskDetailRandoms[2],
          this.maskDetailRandoms[3],
          this.maskDetailRandoms[4]
        );
        var top_right_translated_mask = gmChecker.computeRotatedPoint(
          x_max,
          y_min,
          this.maskDetailRandoms[2],
          this.maskDetailRandoms[3],
          this.maskDetailRandoms[4]
        );
        top_left_translated_mask.x += this.maskDetailRandoms[0];
        bot_right_translated_mask.x += this.maskDetailRandoms[0];
        bot_left_translated_mask.x += this.maskDetailRandoms[0];
        top_right_translated_mask.x += this.maskDetailRandoms[0];
        top_left_translated_mask.y += this.maskDetailRandoms[1];
        bot_right_translated_mask.y += this.maskDetailRandoms[1];
        bot_left_translated_mask.y += this.maskDetailRandoms[1];
        top_right_translated_mask.y += this.maskDetailRandoms[1];

        let eyeNotInside = 0;
        let mouthNotInside = 0;
        if (
          !gmChecker.checkIfPointInsideRectangle(
            this.top_left_translated,
            top_left_translated_mask,
            top_right_translated_mask,
            bot_right_translated_mask,
            bot_left_translated_mask
          )
        ) {
          eyeNotInside++;
        }
        if (
          !gmChecker.checkIfPointInsideRectangle(
            this.top_right_translated,
            top_left_translated_mask,
            top_right_translated_mask,
            bot_right_translated_mask,
            bot_left_translated_mask
          )
        ) {
          eyeNotInside++;
        }
        if (
          !gmChecker.checkIfPointInsideRectangle(
            this.bot_right_translated,
            top_left_translated_mask,
            top_right_translated_mask,
            bot_right_translated_mask,
            bot_left_translated_mask
          )
        ) {
          mouthNotInside++;
        }
        if (
          !gmChecker.checkIfPointInsideRectangle(
            this.bot_left_translated,
            top_left_translated_mask,
            top_right_translated_mask,
            bot_right_translated_mask,
            bot_left_translated_mask
          )
        ) {
          mouthNotInside++;
        }
        if (mouthNotInside + eyeNotInside <= 3) {
          return true;
        } else {
          return false;
        }
      } else {
        var p1x = 18;
        var p1y =
          7.75128869404 - 6 * ((this.maskDetailRandoms[5] * 1.5) / 2) * 2;
        var p2x =
          32 + 6 * ((this.maskDetailRandoms[5] * 1.5) / 2) * Math.sqrt(3);
        var p2y = 32 + 6 * ((this.maskDetailRandoms[5] * 1.5) / 2);
        var p3x =
          4 - 6 * ((this.maskDetailRandoms[5] * 1.5) / 2) * Math.sqrt(3);
        var p3y = 32 + 6 * ((this.maskDetailRandoms[5] * 1.5) / 2);
        this.p1_translated = gmChecker.computeRotatedPoint(
          p1x,
          p1y,
          this.maskDetailRandoms[7],
          18,
          18
        );
        this.p2_translated = gmChecker.computeRotatedPoint(
          p2x,
          p2y,
          this.maskDetailRandoms[7],
          18,
          18
        );
        this.p3_translated = gmChecker.computeRotatedPoint(
          p3x,
          p3y,
          this.maskDetailRandoms[7],
          18,
          18
        );
        this.p1_translated.x += this.maskDetailRandoms[0];
        this.p2_translated.x += this.maskDetailRandoms[0];
        this.p3_translated.x += this.maskDetailRandoms[0];
        this.p1_translated.y += this.maskDetailRandoms[1] - 2.5;
        this.p2_translated.y += this.maskDetailRandoms[1] - 2.5;
        this.p3_translated.y += this.maskDetailRandoms[1] - 2.5;

        let eyeNotInside = 0;
        let mouthNotInside = 0;
        if (
          !gmChecker.checkIfPointInsideTriangle(
            this.top_left_translated,
            this.p1_translated,
            this.p2_translated,
            this.p3_translated
          )
        ) {
          eyeNotInside++;
        }
        if (
          !gmChecker.checkIfPointInsideTriangle(
            this.top_right_translated,
            this.p1_translated,
            this.p2_translated,
            this.p3_translated
          )
        ) {
          eyeNotInside++;
        }
        if (
          !gmChecker.checkIfPointInsideTriangle(
            this.bot_right_translated,
            this.p1_translated,
            this.p2_translated,
            this.p3_translated
          )
        ) {
          mouthNotInside++;
        }
        if (
          !gmChecker.checkIfPointInsideTriangle(
            this.bot_left_translated,
            this.p1_translated,
            this.p2_translated,
            this.p3_translated
          )
        ) {
          mouthNotInside++;
        }
        if (mouthNotInside + eyeNotInside <= 3) {
          return true;
        } else {
          return false;
        }
      }
    },
    initializeColor() {
      // this.colorPair = colors[Math.floor(Math.random() * colors.length)];
      // this.colorPair = colors[colors.length - 1];

      if (Math.random() > 0.5) {
        // switch content of colorPair
        let temp = this.colorPair[0];
        this.colorPair[0] = this.colorPair[1];
        this.colorPair[1] = temp;
      }
      // 0 is background
      // 1 is foreground
      // console.log(reshading.colorBrightness(this.colorPair[0]));
      // console.log(reshading.colorBrightness(this.colorPair[1]));
      if (reshading.checkColorIsBright(this.colorPair[0])) {
        if (reshading.checkColorIsBright(this.colorPair[1])) {
          if (
            reshading.colorBrightness(this.colorPair[0]) >
            reshading.colorBrightness(this.colorPair[1])
          ) {
            let foregroundHSL = reshading.hexToHSL(this.colorPair[1]);
            let backgroundHSL = reshading.hexToHSL(this.colorPair[0]);
            this.backgroundStroke =
              "hsl(" +
              foregroundHSL[0] +
              ", " +
              foregroundHSL[1] / 1.5 +
              "%, " +
              Math.min(100, (backgroundHSL[2] + 10) * 1.5) +
              "%)";
            this.foregroundStroke =
              "hsl(" +
              backgroundHSL[0] +
              ", " +
              backgroundHSL[1] / 1.5 +
              "%, " +
              Math.min(100, (foregroundHSL[2] + 10) * 1.5) +
              "%)";
          } else {
            let foregroundHSL = reshading.hexToHSL(this.colorPair[1]);
            let backgroundHSL = reshading.hexToHSL(this.colorPair[0]);
            this.foregroundStroke =
              "hsl(" +
              backgroundHSL[0] +
              ", " +
              backgroundHSL[1] / 1.5 +
              "%, " +
              Math.min(100, (foregroundHSL[2] + 10) * 1.5) +
              "%)";
            this.backgroundStroke =
              "hsl(" +
              foregroundHSL[0] +
              ", " +
              foregroundHSL[1] / 1.5 +
              "%, " +
              Math.min(100, (backgroundHSL[2] + 10) * 1.5) +
              "%)";
          }
        } else {
          // background is bright, foreground is dark
          this.foregroundStroke = "#ffffee";
          let foregroundHSL = reshading.hexToHSL(this.colorPair[1]);
          let backgroundHSL = reshading.hexToHSL(this.colorPair[0]);
          this.backgroundStroke =
            "hsl(" +
            foregroundHSL[0] +
            ", " +
            foregroundHSL[1] / 2 +
            "%, " +
            Math.min(100, (backgroundHSL[2] + 25) * 2.5) +
            "%)";
        }
      } else {
        if (!reshading.checkColorIsBright(this.colorPair[1])) {
          // both are dark
          this.foregroundStroke = "#ffffee";
          this.backgroundStroke = "#ffffee";
        } else {
          // foreground is bright, background is dark
          let temp = this.colorPair[0];
          this.colorPair[0] = this.colorPair[1];
          this.colorPair[1] = temp;
          this.foregroundStroke = "#ffffee";
          let foregroundHSL = reshading.hexToHSL(this.colorPair[1]);
          let backgroundHSL = reshading.hexToHSL(this.colorPair[0]);
          this.backgroundStroke =
            "hsl(" +
            foregroundHSL[0] +
            ", " +
            foregroundHSL[1] / 2 +
            "%, " +
            Math.min(100, (backgroundHSL[2] + 15) * 1.5) +
            "%)";
        }
      }
    },

    initializationFull() {
      this.mouthStyle = Math.random() > 0.5 ? 0 : 1;
      this.mouthHappy = Math.random() > 0.4;
      this.faceStyle = Math.random() > 0.75;
      let colorPick1 = Math.floor(Math.random() * colors.length);
      let colorPick2 = Math.floor(Math.random() * colors.length);
      while (colorPick2 == this.colorPick1) {
        colorPick2 = Math.floor(Math.random() * colors.length);
      }
      let color1_dark = reshading.checkColorIsBright(colors[colorPick1]);
      let color2_dark = reshading.checkColorIsBright(colors[colorPick2]);
      while (!color1_dark == color2_dark) {
        colorPick1 = Math.floor(Math.random() * colors.length);
        colorPick2 = Math.floor(Math.random() * colors.length);
        while (colorPick2 == this.colorPick1) {
          colorPick2 = Math.floor(Math.random() * colors.length);
        }
        color1_dark = reshading.checkColorIsBright(colors[colorPick1]);
        color2_dark = reshading.checkColorIsBright(colors[colorPick2]);
      }

      this.colorPair = [colors[colorPick1], colors[colorPick2]];
      this.initializeColor();
      this.initialization();
      while (!this.checkIfMostlyInside()) {
        this.initialization();
      }
    },

    downloadSVGAsPNG() {
      // download our svg as png
      const svg = document.getElementById("avatar");
      const svgData = new XMLSerializer().serializeToString(svg);
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");
      const img = document.createElement("img");
      const svgSize = svg.getBoundingClientRect();
      canvas.width = svgSize.width;
      canvas.height = svgSize.height;
      img.setAttribute("src", "data:image/svg+xml;base64," + btoa(svgData));
      img.onload = function () {
        ctx.drawImage(img, 0, 0);
        const a = document.createElement("a");
        const e = new MouseEvent("click");
        a.download = "avatar.png";
        a.href = canvas.toDataURL("image/png");
        a.dispatchEvent(e);
      };
    },
    downloadSVGAsText() {
      const svg = document.getElementById("avatar");
      const base64doc = btoa(unescape(encodeURIComponent(svg.outerHTML)));
      const a = document.createElement("a");
      const e = new MouseEvent("click");
      a.download = "avatar.svg";
      a.href = "data:image/svg+xml;base64," + base64doc;
      a.dispatchEvent(e);
    },
    keypress(e) {
      if (e.key === "r") {
        this.initializationFull();
      } else if (e.key === "s") {
        this.downloadSVGAsText();
      } else if (e.key === "p") {
        this.downloadSVGAsPNG();
      }
    },
  },

  computed: {
    leftEyeStart() {
      return (
        this.svgViewBoxSize / 2 -
        this.distanceBetweenEyes.getSize() / 2 -
        this.eyeWidth.getSize()
      );
    },
    rightEyeStart() {
      return this.svgViewBoxSize / 2 + this.distanceBetweenEyes.getSize() / 2;
    },
    mouthStartX() {
      return this.svgViewBoxSize / 2 - this.mouthWidth.getSize() / 2;
    },
  },
  mounted() {},
  created() {
    this.initializationFull();
    window.addEventListener("keypress", this.keypress);
    // window.addEventListener("keydown", this.keydown);
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.container {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: inline-flex;
  /* align-items items in column */
  flex-direction: column;
  /* center items horizontally */
  align-items: center;
  /* center items vertically */
  justify-content: center;
}
svg {
  margin-bottom: 10px;
}

button {
  margin-top: 10px;
  width: 200px;
  padding: 10px;
  background: transparent;
  border-width: 2px;
  font-size: 25px;
  border-color: black;
  color: black;
  font-weight: bold;
  user-select: none;
  border-radius: 10px;
  box-shadow: 4px 4px 4px 0px rgba(0, 0, 0, 0.75);
}

button:hover {
  background: black;
  color: white;
  transition: 0.3s;
}
button:active {
  background: rgb(65, 65, 65);
  box-shadow: 2px 2px 2px 0px rgba(0, 0, 0, 0.75);
}

.createdBy {
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translate(-50%, 0%);
  text-align: center;
  font-size: 10px;
  z-index: 100;
  -webkit-user-select: none;
  /* Safari */
  -ms-user-select: none;
  /* IE 10 and IE 11 */
  user-select: none;
  /* Standard syntax */
  font-weight: bold;
  color: black;
}
</style>
